import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { ProfileQueryKey } from './queryKey';
export var useEnable2FA = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (values) {
        return api.base
            .post('/api/user/Enable2FA', values)
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function () {
            queryClient.invalidateQueries([ProfileQueryKey.Profile]);
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { enable2FA: mutateAsync, isLoading: isLoading };
};
